var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMediaUnsplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-media-unsplash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-20.000000, -396.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-media-unsplash",
    transform: "translate(20.000000, 396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4004286,0.857142857 C12.0098571,0.857142857 12.54,1.29085714 12.6608571,1.88828571 L12.8331429,2.74114286 C12.9137143,3.141 13.2651429,3.42857143 13.6731429,3.42857143 L15.8571429,3.42857143 C16.566,3.42857143 17.1428571,4.00542857 17.1428571,4.71428571 L17.1428571,13.7142857 C17.1428571,14.4231429 16.566,15 15.8571429,15 L2.14285714,15 C1.434,15 0.857142857,14.4231429 0.857142857,13.7142857 L0.857142857,4.71428571 C0.857142857,4.00542857 1.434,3.42857143 2.14285714,3.42857143 L4.32685714,3.42857143 C4.73485714,3.42857143 5.08628571,3.141 5.16685714,2.74114286 L5.33914286,1.88828571 C5.46,1.29085714 5.99014286,0.857142857 6.59957143,0.857142857 L11.4004286,0.857142857 M11.4004286,0 L6.59957143,0 C5.57957143,0 4.701,0.719142857 4.49914286,1.71857143 L4.32685714,2.57142857 L2.14285714,2.57142857 C0.959571429,2.57142857 0,3.531 0,4.71428571 L0,13.7142857 C0,14.8975714 0.959571429,15.8571429 2.14285714,15.8571429 L15.8571429,15.8571429 C17.0404286,15.8571429 18,14.8975714 18,13.7142857 L18,4.71428571 C18,3.531 17.0404286,2.57142857 15.8571429,2.57142857 L13.6731429,2.57142857 L13.5008571,1.71857143 C13.299,0.718714286 12.4204286,0 11.4004286,0 L11.4004286,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.714286, 4.714286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28571429,0.857142857 C6.17614286,0.857142857 7.71428571,2.39528571 7.71428571,4.28571429 C7.71428571,6.17614286 6.17614286,7.71428571 4.28571429,7.71428571 C2.39528571,7.71428571 0.857142857,6.17614286 0.857142857,4.28571429 C0.857142857,2.39528571 2.39528571,0.857142857 4.28571429,0.857142857 M4.28571429,0 C1.91871429,0 0,1.91871429 0,4.28571429 C0,6.65271429 1.91871429,8.57142857 4.28571429,8.57142857 C6.65271429,8.57142857 8.57142857,6.65271429 8.57142857,4.28571429 C8.57142857,1.91871429 6.65271429,0 4.28571429,0 L4.28571429,0 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediaUnsplash);
export default __webpack_public_path__ + "static/media/icon-media-unsplash.da7ed0e1c3d5f31463fc1e14b7bb9e5b.svg";
export { ForwardRef as ReactComponent };